import { SpringAPI } from 'defs/http/api';
import axios from 'helper/axios-facade';

export const updateSettings = (settings: Object = {}) => {
	const requestUrl = SpringAPI.settings.updateSettings();
	return axios.put(requestUrl, settings);
};
